import { useEffect, useRef, useState } from 'react';
import { DEPARTING, RETURNING } from '../constants';

const useFlightsQueryLoadingStatus = (tabDates, networkStatus) => {
  const [isFetchingDeparting, setIsFetchingDeparting] = useState(false);
  const [isFetchingReturning, setIsFetchingReturning] = useState(false);
  const departingSelectedRef = useRef(tabDates[DEPARTING]?.selected);
  const returningSelectedRef = useRef(tabDates[RETURNING]?.selected);

  useEffect(() => {
    if (
      networkStatus === 2 &&
      tabDates[DEPARTING]?.selected !== departingSelectedRef.current
    ) {
      setIsFetchingDeparting(true);
    } else {
      departingSelectedRef.current = tabDates[DEPARTING]?.selected;
      setIsFetchingDeparting(false);
    }
  }, [tabDates, networkStatus]);

  useEffect(() => {
    if (
      networkStatus === 2 &&
      tabDates[RETURNING]?.selected !== returningSelectedRef.current
    ) {
      setIsFetchingReturning(true);
    } else {
      returningSelectedRef.current = tabDates[RETURNING]?.selected;
      setIsFetchingReturning(false);
    }
  }, [tabDates, networkStatus]);

  return {
    isFetchingDeparting,
    isFetchingReturning,
  };
};

export default useFlightsQueryLoadingStatus;
